import type { MessageLanguageSource } from '@shared/core/localized-defaults'
import { useIntl } from 'react-intl'
import { formatCountryName } from 'src/modules/core/utils/country.utils'

/** Where the account language comes from; `null` for a template language, which each caller words itself. */
export function useMessageLanguageSourceText(source: MessageLanguageSource, countryCode: string | null): string | null {
  const { formatMessage } = useIntl()
  if (source === 'account') return formatMessage({ id: 'settings.messageLanguage.notice.sourceAccount' })
  if (source === 'template') return null
  const country = formatCountryName(countryCode)
  return country
    ? formatMessage({ id: 'settings.messageLanguage.notice.sourceCountry' }, { country })
    : formatMessage({ id: 'settings.messageLanguage.noCountry' })
}
